<template>
  <div>
    <el-form-item label="是否考试：" required class="width100">
      <el-radio-group v-model="form.isExam">
        <el-radio :label="1">考试</el-radio>
        <el-radio :label="0">不考试</el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="form.isExam">
      <el-form-item label="试卷题目：" prop="topicClassificationId" class="width100">
        <el-select v-model="form.topicClassificationId" placeholder="请选择" clearable size="small">
          <el-option v-for="(item,index) in topicClassOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试题数：" prop="examNum">
        <el-input v-model="form.examNum" placeholder="请输入考试题数" />
      </el-form-item>
      <el-form-item label="单题分数：" prop="examSingleScore">
        <el-input v-model="form.examSingleScore" placeholder="请输入每道题得分">
          <i class="el-input__icon" slot="suffix">分</i>
        </el-input>
      </el-form-item>
      <el-form-item label="总分：">
        <el-input v-model="examTotalScore" placeholder="根据单题分数和考试题数算出总分" disabled>
          <i class="el-input__icon" slot="suffix">分</i>
        </el-input>
      </el-form-item>
      <el-form-item label="考试达标分数：" prop="achievementScore">
        <el-input v-model="form.achievementScore" placeholder="请输入考试达标分数" />
      </el-form-item>
      <el-form-item label="考试学分：" prop="examCredits">
        <el-input v-model="form.examCredits" placeholder="请输入考试完成后获得的学分" />
      </el-form-item>
      <el-form-item label="是否能看答案：" prop="isLookSolution">
        <el-select v-model="form.isLookSolution" placeholder="请选择" clearable size="small">
          <el-option label="允许查看" :value="1"></el-option>
          <el-option label="不允许查看" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试次数：" prop="examOrder">
        <el-input v-model="form.examOrder" placeholder="请输入考试次数" />
      </el-form-item>
      <el-form-item label="考试时长：" prop="examDuration">
        <el-input v-model="form.examDuration" placeholder="请输入考试时长">
          <i slot="suffix" class="el-input__icon">分钟</i>
        </el-input>
      </el-form-item>
      <el-form-item label="考试规则：" prop="examRules" class="width100">
        <el-select v-model="form.examRules" placeholder="请选择" clearable size="small">
          <el-option label="学习完考" :value="1"></el-option>
          <el-option label="不限制" :value="0"></el-option>
        </el-select>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import { accMul } from '@/utils/index'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
export default {
  props: ['form'],
  data() {
    return {
      topicClassOptions: []
    }
  },
  created() {
    courseTopicClassificationApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1, purposeType: 3 }).then(({ data }) => this.topicClassOptions = data.list)
  },
  computed: {
    examTotalScore() {
      let score = null
      let { examNum, examSingleScore } = this.form
      if (examNum && examSingleScore) {
        score = accMul(examNum, examSingleScore)
        this.form.examTotalScore = score
      }
      return score
    }
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>